<template>
  <div>
    <Modal
      @closeModal="$emit('close-clicked')"
      modal_style="rounded-15 modal-md-lg"
    >
      <!-- MODAL TITLE -->
      <div slot="modal-title"></div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="recommendation-body">
          <div class="title-text brand_navy font-weight-bold w-100 text-center">
            What's Next?
          </div>

          <div class="recommendation-cards px-1 px-md-4">
            <div
              class="card-box mx-2"
              :class="'card' + index"
              v-for="(recommend, index) in daily_recommendations"
              :key="index"
            >
              <RecommendCard
                theme="dark"
                :topic="recommend.topic"
                v-if="recommend.type == 'single'"
                :topic_type="recommend.type"
                :subject_id="recommend.topic.subject_id"
                card_type="practice"
                :card_img="recommend.topic.image"
                card_title="Single Practice"
                :card_topic="recommend.topic.topic"
                :show_lock="true"
                :completed_card="recommend.is_done"
                :show_button="false"
                :opacify_card="index"
                :custom_height="true"
                custom_height_value="black daily-recommendation-card-height"
              />

              <RecommendCard
                theme="dark"
                :topic="recommend.topic"
                v-else-if="recommend.type == 'mix'"
                :topic_data="recommend.topic"
                :topic_type="recommend.type"
                :subject_id="recommend.topic[0].subject_id"
                card_type="practice"
                :card_img="recommend.topic[0].image"
                card_title="Mix Practice"
                :card_topic="recommend.topic[0].topic"
                :show_lock="true"
                :completed_card="recommend.is_done"
                :show_button="false"
                :opacify_card="index"
                :custom_height="true"
                custom_height_value="black daily-recommendation-card-height"
              />

              <RecommendCard
                v-else
                theme="dark"
                card_type="video"
                card_title="Video Lesson"
                :video_id="recommend.token"
                :card_img="recommend.image || 'VideoCardOne.png'"
                :card_topic="recommend.new_title"
                :card_meta="recommend.time_remaining"
                :show_lock="true"
                :completed_card="recommend.is_done"
                :opacify_card="index"
                :custom_height="true"
                custom_height_value="black daily-recommendation-card-height"
              ></RecommendCard>
            </div>
          </div>

          <div class="meta-text color_text w-100 text-center">
            You are on track to completing your recommendation for today
          </div>

          <div class="button-row d-flex justify-content-center">
            <button
              class="btn btn-accent font-weight-bold brand_navy"
              @click="triggerClickOnCard"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "DailyRecommendationModal",

  components: {
    Modal,
    RecommendCard: () =>
      import(
        /* webpackChunkName: "RecommendCard" */
        "@/components/classComps/catchup/RecommendCard"
      ),
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),
  },

  data() {
    return {
      account_type: "",
      child_id: null,
      daily_recommendations: [],
    };
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    ...mapActions(["getDailyRecommendation"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      if (this.account_type === "parent")
        this.child_id = this.getSelectedChildID;

      this.loadRecommendation();
    },

    loadRecommendation() {
      this.getDailyRecommendation(this.child_id)
        .then((res) => {
          if (res.code === 200) {
            let done = [];
            let undone = [];

            res.data.map((item) => {
              if (item.is_done) done.push(item);
              else undone.push(item);
            });

            if (undone.length > 1)
              this.daily_recommendations = [
                done[done.length - 1],
                undone[0],
                undone[1],
              ];
            else if (undone.length === 1)
              this.daily_recommendations = [
                done[done.length - 2],
                undone[0],
                done[done.length - 1],
              ];

            // console.log(this.daily_recommendations);
          } else {
            console.log(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    triggerClickOnCard() {
      this.$emit("close-clicked");
      this.$bus.$emit(
        "event-bus-continue-practice",
        this.daily_recommendations[1]
      );
    },
  },
};
</script>

<style lang="scss">
.recommendation-body {
  margin-top: -35px;
  .title-text {
    margin-bottom: 20px;
    font-size: 21px;
    line-height: 29px;

    @include breakpoint_max(sm) {
      margin-top: 20px;
      font-size: 19px;
      line-height: 19px;
    }
  }

  .recommendation-cards {
    @include flex_row_center_nowrap;
    overflow: auto;
    width: 100%;

    @include breakpoint_max(sm) {
      @include flex_row_start_nowrap;
    }
  }

  .meta-text {
    font-size: 14px;
    line-height: 19px;
    margin-top: 20px;
    margin-bottom: 27px;

    @include breakpoint_max(sm) {
      font-size: 13px;
      line-height: 17px;
    }
  }

  .button-row {
    @include breakpoint_max(sm) {
      margin-bottom: -15px;
    }

    .btn {
      @include breakpoint_max(sm) {
        font-size: 10px;
        padding: 12px;
        min-width: 115px;
        width: 115px;
      }
    }
  }
}
</style>
